<div
  class="eiq-file-upload-container"
  dragAndDrop
  [attr.data-testid]="testId() ? testId() + '-file-uploader' : null"
  [class.eiq-uploading]="uploading()"
  (fileDropped)="onFileDropped($event)"
>
  <input
    [attr.data-testid]="testId() ? testId() + '-input' : null"
    id="fileDropRef"
    type="file"
    #fileDropRef
    [accept]="acceptedTypes()"
    [multiple]="multiple()"
    (change)="fileBrowseHandler($event)"
  />
  <div class="eiq-file-main-icon">
    <fa-icon [icon]="faPhotoFilm"></fa-icon>
  </div>
  <div class="eiq-file-main-text">
    <label [attr.data-testid]="testId() ? testId() + '-label' : null" for="fileDropRef">Click to upload</label>
    <span> or drag and drop</span>
  </div>
  <span class="eiq-file-sub-text">Supported formats: {{ acceptedTypesText().join(', ') }}</span>
  <span class="eiq-file-sub-text">Max file size: {{ maxSize() }} MB</span>

  <div class="eiq-updating__container">
    <div class="eiq-uploading__cover"></div>
    <span class="eiq-uploading__text">Uploading...</span>
  </div>
</div>
